import { render, staticRenderFns } from "./DocumentAnalysis.vue?vue&type=template&id=5cb943b2&"
import script from "./DocumentAnalysis.vue?vue&type=script&lang=ts&"
export * from "./DocumentAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports